module.exports = __webpack_public_path__ + "static/media/light_en.5c2ae3c5.svg";